import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { recomputeAllFromLiveData } from '../../services/growthMetricsService';

/**
 * Owner-triggered "turn it on" button (Phase: activation). Recomputes + persists every barber's Growth
 * snapshot from live data. After it runs, the growth badges populate on next profile render.
 * BEHAVIOR-PIN: SLIK-GROWTH-SYSTEM-BLUEPRINT.md · math shared/growth.ts · orchestration growthMetricsService.
 */
export const GrowthRecomputeButton: React.FC<{ className?: string; onComplete?: () => void }> = ({ className, onComplete }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const res = await recomputeAllFromLiveData();
      const n = res.filter(Boolean).length;
      toast.success(`Growth scores updated for ${n} barber${n === 1 ? '' : 's'}.`);
      onComplete?.();
    } catch (e: any) {
      toast.error('Growth recompute failed: ' + (e?.message || 'error'));
      // eslint-disable-next-line no-console
      console.error('[GrowthRecompute]', e);
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      type="button"
      onClick={run}
      disabled={busy}
      title="Recompute every barber's Growth Score from live data"
      className={`px-3 py-1.5 rounded-lg text-xs md:text-sm font-medium bg-purple-600 text-white hover:bg-purple-700 disabled:opacity-60 touch-manipulation ${className || ''}`}
    >
      {busy ? 'Recomputing…' : '↻ Recompute Growth'}
    </button>
  );
};

export default GrowthRecomputeButton;
